import { buildSearchMap } from '@/components/FileBrowser/utils/utils';
import type { Folder } from '@types';

// eslint-disable-next-line import/prefer-default-export
export const getMostRecentFiles = (files: Folder, limit: number) => {
  const shouldExclude = (path: string, segment: string) => {
    const parts = path.split('/').filter(Boolean);
    const idx = parts.indexOf(segment);
    return idx > 0 && idx < parts.length - 1;
  };

  const EXCLUDED_SEGMENTS = ['investor-reporting', 'general-ledger-excel'];

  return buildSearchMap(files)
    .filter((f) => f.type === 'file')
    .filter((f) =>
      EXCLUDED_SEGMENTS.every((segment) => !shouldExclude(f.path, segment))
    )
    .sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1))
    .slice(0, limit);
};
